/* eslint-disable camelcase */
import axios from '@axios'

export const state = {
  reports: [],
  decryptedReports: [],
  currentPage: 1,
  perPage: 15,
  totalPages: 1,
  totalRecords: '',
  exporteds: [],
  exportCurrentPage: 1,
  exportPerPage: 15,
  exportTotalPages: 1,
  exportTotalRecords: 0,
}

export const getters = {
  allReports: (state) => state.reports,
  currentPage: (state) => state.currentPage,
  totalPages: (state) => state.totalPages,
  totalRecords: (state) => state.totalRecords,
  perPage: (state) => state.perPage,
  allDecryptedReports: (state) => state.decryptedReports,
  allExports: (state) => state.exporteds,
  exportCurrentPage: (state) => state.exportCurrentPage,
  exportPerPage: (state) => state.exportPerPage,
  exportTotalPages: (state) => state.exportTotalPages,
  exportTotalRecords: (state) => state.exportTotalRecords,
}

export const mutations = {
  GET_REPORTS: (state, data) => {
    if (!data) {
      state.reports = []
      state.currentPage = 1
      state.perPage = 15
      state.totalPages = 1
      state.totalRecords = ''
      return false
    }
    state.decryptedReports = []
    state.reports = data.reports
    state.reports.forEach((report) => {
      state.decryptedReports.push({
        id: report.id,
        decrypted: false,
        content: '',
      })
    })
    let { reports, page, perPage, totalPages, totalRecords } = data
    state.reports = reports
    state.currentPage = page
    state.totalPages = totalPages
    state.perPage = perPage
    state.totalRecords = totalRecords
  },
  DECRYPTREPORT: (state, data) => {
    if (!data) {
      return false
    }
    for (let index = 0; index < state.reports.length; index++) {
      if (state.reports[index].id === data.id) {
        if (!data.is_masked) {
          state.decryptedReports[index].content = state.reports[index].content
          state.decryptedReports[index].message = state.reports[index].message
        }

        state.reports[index].content = data.content
        state.reports[index].message = data.message
        state.decryptedReports[index].decrypted = true
      }
    }
  },
  ENCRYPTREPORT: (state, data) => {
    if (!data) {
      return false
    }
    for (let index = 0; index < state.reports.length; index++) {
      if (state.reports[index].id === data.id) {
        state.reports[index].content = state.decryptedReports[index].content
        state.reports[index].message = state.decryptedReports[index].message
        state.decryptedReports[index].decrypted = false
      }
    }
  },
  GET_EXPORT_REPORT: (state, data) => {
    if (!data) {
      state.exporteds = []
      state.exportCurrentPage = 1
      state.exportPerPage = 15
      state.exportTotalPages = 1
      state.exportTotalRecords = 0
      return
    }
    state.exporteds = Array.isArray(data.reports) ? data.reports : []
    state.exportCurrentPage =
      typeof data.page === 'number' ? data.page : state.exportCurrentPage
    state.exportPerPage =
      typeof data.perPage === 'number' ? data.perPage : state.exportPerPage
    state.exportTotalPages =
      typeof data.totalPages === 'number'
        ? data.totalPages
        : state.exportTotalPages
    state.exportTotalRecords =
      typeof data.totalRecords === 'number'
        ? data.totalRecords
        : state.exportTotalRecords
  },
  REMOVE_EXPORT_REPORT: (state, id) => {
    state.exporteds = state.exporteds.filter((c) => c.id !== id)
  },
}

export const actions = {
  async getReports({ commit, dispatch }, { paginate }) {
    dispatch('layout/changeLoading', true, { root: true })
    await axios
      .get(`/sms/reports/transactions`, { params: paginate })
      .then((resp) => {
        if (resp.status === 200) {
          commit('GET_REPORTS', resp.data)
          dispatch('layout/changeLoading', false, { root: true })
        }
      })
      .catch(() => {
        commit('GET_REPORTS', '')
        dispatch('layout/changeLoading', false, { root: true })
      })
      .finally(() => {
        dispatch('layout/changeLoading', false, { root: true })
      })
  },
  async decryptReport({ commit, dispatch }, payload) {
    let report = payload.report
    let params = payload.params
    dispatch('layout/changeLoading', true, { root: true })
    return axios
      .get(`/sms/reports/transactions/${report.id}/decode`, {
        params: params,
      })
      .then((resp) => {
        if (resp.status === 200) {
          commit('DECRYPTREPORT', {
            ...resp.data,
            ...{ is_masked: params.unmask },
          })
          dispatch('layout/changeLoading', false, { root: true })
        }
      })
      .catch((err) => {
        if (err.response.status === 403) {
          commit('DECRYPTREPORT', '')
          let notification = {
            id: Date.now(),
            message: "You don't have permission to decrypt the content",
          }
          dispatch('notification/addNotification', notification, {
            root: true,
          })
          dispatch('layout/changeLoading', false, { root: true })
        } else {
          commit('DECRYPTREPORT', '')
          let notification = {
            id: Date.now(),
            message: 'Cannot decrypt the content',
          }
          dispatch('notification/addNotification', notification, {
            root: true,
          })
          dispatch('layout/changeLoading', false, { root: true })
        }
      })
      .finally(() => {
        dispatch('layout/changeLoading', false, { root: true })
      })
  },
  async encryptReport({ commit, dispatch }, report) {
    commit('ENCRYPTREPORT', report)
  },
  async exportTraffice({ commit, dispatch }, { params }) {
    dispatch('layout/changeLoading', true, { root: true })
    return axios.get(`/sms/reports/transactions/export`, { params: params })
  },
  async getExportReports({ commit }, params = {}) {
    const query = { perPage: 15, ...params }
    await axios
      .get('/sms/reports/transactions/exports', { params: query })
      .then((res) => {
        if (res.status === 200) {
          commit('GET_EXPORT_REPORT', res.data)
        }
      })
  },
  async removeExportReport({ commit }, exportId) {
    return axios.delete(`/users/profile/upload-document/${exportId}`).then((res) => {
      if (res.status === 204) {
        commit("REMOVE_EXPORT_REPORT", res.data.reports)
      }
    })
  },
}
